import { getPlanDetail } from '../../../api/planApi'
import { getPaginatedVersions } from '../../../api/versionApi'
import PlanDescriptions from '../../../components/plans/plan-descriptions/plan-descriptions'
import { IVersion, VersionItemTypeEnums } from '../../versions-container/share-type'
import { IPlan } from '../share-type'
import styles from './plan.module.less'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { compose } from 'redux'

const Plan = () => {
  const params = useParams()
  const [planId] = useState<string | undefined>(params?.id)
  const [plan, setPlan] = useState<IPlan>()
  const [versions, setVersions] = useState<IVersion[]>([])

  useEffect(() => {
    if (planId) {
      getPlanDetail(Number(planId)).then(res => {
        setPlan(res)
      })
      getPaginatedVersions({
        itemType: VersionItemTypeEnums.PLAN,
        itemId: Number(planId),
        page: 0,
        size: 999,
      }).then(res => {
        setVersions(res.data)
      })
    }
  }, [planId])

  return (
    <Space className={styles['plan-desc-wrapper']} orientation="vertical" size={16}>
      {plan && <PlanDescriptions plan={plan} versions={versions} />}
    </Space>
  )
}

const mapStateToProps = () => ({})

const withConnect = connect(mapStateToProps)

export default compose(withConnect)(Plan)
